import React, { Component } from "react";
import HabitScorecard from "./HabitScorecard";
import Wizard from "./Wizard";

class App extends Component {
  constructor(props) {
    super(props);
    let visited = localStorage.getItem("visited");

    if (!visited) {
      localStorage.setItem("visited", true);
      this.state = {
        wizardComplete: false
      };
    } else {
      this.state = {
        wizardComplete: true
      };
    }
  }

  toggleWizardComplete = () => {
    this.setState(prevState => ({
      wizardComplete: !prevState.wizardComplete
    }));
  };

  render() {
    let { wizardComplete } = this.state;
    if (wizardComplete) {
      return <HabitScorecard />;
    }
    return <Wizard wizardComplete={this.toggleWizardComplete} />;
  }
}

export default App;
